import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import WorkOrders from "@/pages/WorkOrders";
import Inventory from "@/pages/Inventory";
import Tyres from "@/pages/Tyres";
import Batteries from "@/pages/Batteries";
import Consumables from "@/pages/Consumables";
import PMSchedules from "@/pages/PMSchedules";
import Vendors from "@/pages/Vendors";
import Locations from "@/pages/Locations";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Drivers from "@/pages/Drivers";
import Compliance from "@/pages/Compliance";
import Approvals from "@/pages/Approvals";
import OdometerUpdate from "@/pages/OdometerUpdate";
import MileageCalculation from "@/pages/MileageCalculation";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="vehicles" element={<Vehicles />} />
                            <Route path="vehicles/:id" element={<VehicleDetail />} />
                            <Route path="update-km" element={<OdometerUpdate />} />
                            <Route path="mileage" element={<MileageCalculation />} />
                            <Route path="drivers" element={<Drivers />} />
                            <Route path="compliance" element={<Compliance />} />
                            <Route path="work-orders" element={<WorkOrders />} />
                            <Route path="inventory" element={<Inventory />} />
                            <Route path="tyres" element={<Tyres />} />
                            <Route path="batteries" element={<Batteries />} />
                            <Route path="consumables" element={<Consumables />} />
                            <Route path="pm-schedules" element={<PMSchedules />} />
                            <Route path="vendors" element={<Vendors />} />
                            <Route path="locations" element={<Locations />} />
                            <Route path="reports" element={<Reports />} />
                            <Route path="approvals" element={<Approvals />} />
                            <Route path="users" element={<Users />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster richColors position="top-right" />
            </AuthProvider>
        </div>
    );
}

export default App;
